/*
Copyright (c) 2021
*/

import constants from '../../constants';

const { REQUEST_EDITVIDEONOTE,EDITVIDEONOTE_RECEIVED } = constants.EditVideoNoteConstant;

export default {
    REQUEST_EDITVIDEONOTE,
    EDITVIDEONOTE_RECEIVED,

  requestEditVideoNoteNote: payload => ({
    type: REQUEST_EDITVIDEONOTE,
    payload
  }),
  EditVideoNoteReceived: () => ({
    type: EDITVIDEONOTE_RECEIVED
  }),
};
